import { render, staticRenderFns } from "./KirmiziSantralExtensionMapping.vue?vue&type=template&id=0d6dc0f1"
import script from "./KirmiziSantralExtensionMapping.vue?vue&type=script&lang=js"
export * from "./KirmiziSantralExtensionMapping.vue?vue&type=script&lang=js"
import style0 from "./KirmiziSantralExtensionMapping.vue?vue&type=style&index=0&id=0d6dc0f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports